import { render, staticRenderFns } from "./TreatmentListSection.vue?vue&type=template&id=31630045"
import script from "./TreatmentListSection.vue?vue&type=script&lang=js"
export * from "./TreatmentListSection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentListSection.vue?vue&type=style&index=0&id=31630045&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports